var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "9px",
    viewBox: "0 0 12 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Triangle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    fill: "#0075E3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.83205029,1.24807544 L10.9635332,7.4452998 C11.2698857,7.90482849 11.1457118,8.52569784 10.6861831,8.83205029 C10.5219156,8.94156197 10.3289079,9 10.1314829,9 L1.86851709,9 C1.31623234,9 0.868517092,8.55228475 0.868517092,8 C0.868517092,7.80257501 0.926955119,7.60956732 1.0364668,7.4452998 L5.16794971,1.24807544 C5.47430216,0.788546753 6.09517151,0.664372884 6.5547002,0.970725343 C6.66455248,1.0439602 6.75881544,1.13822315 6.83205029,1.24807544 Z",
    id: "Triangle"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicator);
export default __webpack_public_path__ + "static/media/indicator.823c36f016b925f6278cebc6d719ddeb.svg";
export { ForwardRef as ReactComponent };